import { core_v1_Rule } from '@antimatterhq/asl-api-ts-v1';
import { CodeEditor } from '@antimatterhq/ui/components/codeEditor';
import { Fieldset } from '@antimatterhq/ui/components/fieldset';
import Spacer from '@antimatterhq/ui/components/spacer';

interface RuleSourceReviewProps {
  rule: core_v1_Rule;
}

export function RuleSourceReview({ rule }: RuleSourceReviewProps) {
  const stream = rule.spec.input?.stream;
  const batch = rule.spec.input?.batch;
  const tables = stream?.tables || [];

  if (batch?.sql) {
    return (
      <>
        <Fieldset.Field>
          <Fieldset.Label>Detection SQL:</Fieldset.Label>
        </Fieldset.Field>
        <Fieldset.List>
          <Fieldset.Value>
            {batch.sql && <CodeEditor code={batch.sql} readOnly hideControls />}
            {!batch.sql && <span className="italic">[none]</span>}
          </Fieldset.Value>
        </Fieldset.List>
      </>
    );
  }

  if (batch?.custom?.notebook) {
    return (
      <Fieldset.Field>
        <Fieldset.Label>
          <span className="whitespace-nowrap">Custom Notebook:</span>
        </Fieldset.Label>
        <Fieldset.Value>
          <div className="max-w-[600px] truncate">{batch.custom.notebook}</div>
        </Fieldset.Value>
      </Fieldset.Field>
    );
  }

  return (
    <div>
      {tables.map((table, index) => (
        <div key={index}>
          {index > 0 && <Spacer size="xl" />}

          {table.watermark && (
            <div>
              <Fieldset.Field>
                <Fieldset.Label>{table.name}</Fieldset.Label>
              </Fieldset.Field>
              <Fieldset.List>
                <Fieldset.Field>
                  <Fieldset.Label>
                    <span className="whitespace-nowrap">
                      Event time column:
                    </span>
                  </Fieldset.Label>
                  <Fieldset.Value>
                    <div className="max-w-[600px] truncate">
                      {table.watermark.eventTimeColumn || (
                        <span className="italic">[none]</span>
                      )}
                    </div>
                  </Fieldset.Value>
                </Fieldset.Field>

                <Fieldset.Field>
                  <Fieldset.Label>
                    <span className="whitespace-nowrap">Delay threshold:</span>
                  </Fieldset.Label>
                  <Fieldset.Value>
                    <div className="max-w-[600px] truncate">
                      {table.watermark.delayThreshold || (
                        <span className="italic">[none]</span>
                      )}
                    </div>
                  </Fieldset.Value>
                </Fieldset.Field>

                {table.watermark.dropDuplicates && (
                  <Fieldset.Field>
                    <Fieldset.Label>
                      <span className="whitespace-nowrap">
                        Columns to group-by and drop duplicates:
                      </span>
                    </Fieldset.Label>
                    <Fieldset.Value>
                      <div className="max-w-[600px] truncate">
                        {table.watermark.dropDuplicates.join(', ')}
                      </div>
                    </Fieldset.Value>
                  </Fieldset.Field>
                )}
              </Fieldset.List>
            </div>
          )}

          {table.alias && (
            <Fieldset.Field>
              <Fieldset.Label>
                <span className="whitespace-nowrap">Table alias:</span>
              </Fieldset.Label>
              <Fieldset.Value>
                <div className="max-w-[600px] truncate">{table.alias}</div>
              </Fieldset.Value>
            </Fieldset.Field>
          )}

          {table.joinType && (
            <Fieldset.Field>
              <Fieldset.Label>
                <span className="whitespace-nowrap">Join type:</span>
              </Fieldset.Label>
              <Fieldset.Value>
                <div className="max-w-[600px] truncate">{table.joinType}</div>
              </Fieldset.Value>
            </Fieldset.Field>
          )}

          {table.joinExpr && (
            <Fieldset.Field>
              <Fieldset.Label>
                <span className="whitespace-nowrap">Join expression:</span>
              </Fieldset.Label>
              <Fieldset.Value>
                <div className="max-w-[600px] truncate">{table.joinExpr}</div>
              </Fieldset.Value>
            </Fieldset.Field>
          )}
        </div>
      ))}

      <Spacer size="xl" />

      <Fieldset.Field>
        <Fieldset.Label>Filter (optional):</Fieldset.Label>
        <Fieldset.Value>
          <div className="max-w-[600px] truncate">
            {stream?.filter || <span className="italic">[none]</span>}
          </div>
        </Fieldset.Value>
      </Fieldset.Field>

      <Spacer size="base" />

      <Fieldset.Field>
        <Fieldset.Label>Detection SQL:</Fieldset.Label>
      </Fieldset.Field>
      <Fieldset.List>
        <Fieldset.Value>
          {stream?.sql && (
            <CodeEditor code={stream.sql} readOnly hideControls />
          )}
          {!stream?.sql && <span className="italic">[none]</span>}
        </Fieldset.Value>
      </Fieldset.List>
    </div>
  );
}
